












































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MultiCheckboxFilter extends Vue {
  @Prop({ required: true }) options!: string[];
  @Prop({ default: () => [] }) value!: string[];
  @Prop({ default: "" }) label!: string;

  toggle(option: string) {
    const next = this.value.includes(option)
      ? this.value.filter(v => v !== option)
      : [...this.value, option];
    this.$emit("input", next);
  }

  selectAll() {
    this.$emit("input", [...this.options]);
  }

  clearAll() {
    this.$emit("input", []);
  }
}
